import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString } from "vue"

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    promise: null
  },
  setup(__props: any) {

const props = __props as { promise: Promise<string> }

const text = ref<null | string>("");

watch(
    props,
    (props) => {
        text.value = null;
        props.promise.then((rs) => {
            text.value = rs;
        });
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return _toDisplayString(text.value === null ? "Chargement" : text.value)
}
}

})